import { pushDataLayer } from "../../../Shared/utils/datalayer"

export const pushVBPDataLayer = (data: { category: string; action: string; label: string }) =>
  pushDataLayer({ ...data, event: 'event' })
 
export const pushLocationEvent = (d: {[key: string]: string} ) => 
  pushDataLayer({ event: 'event', category: 'Location', ...d})

export const pushExpand = (label: string) => 
  pushVBPDataLayer({category: 'Location', action: 'Unfold', label: label})

export const pushTag = (label: string) => 
  pushVBPDataLayer({category: 'Activity tag', action: window.location.pathname, label: label})

export const pushCtaBlockAction = (title: string, type: string, label: string) =>
  pushVBPDataLayer({ category: `CTA: ${title}`, action: `cta-action-${type}`, label: label })

export const pushTranslateAction = (label: string) =>
  pushVBPDataLayer({ category: `Translate`, action: `change_language`, label: label })